export default __webpack_public_path__ + "static/media/camera.16227bbc.svg";